// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fcd1c110","845":"2b6cd149"}[chunkId] + ".chunk.js";
};